<div class="border-container">
    <ng-container *ngIf="selectedUserId && !isLoading">
        <div class="mt-2 mb-2">
            <table id="token-list" class="table">
                <caption hidden>
                    Token List
                </caption>
                <thead class="table-dark">
                    <tr>
                        <th scope="col" class="col-3">
                            {{
                                'user.userArea.apiManagement.token' | translate
                            }}
                        </th>
                        <th scope="col" class="col-3">
                            {{
                                'user.userArea.apiManagement.tokenName'
                                    | translate
                            }}
                        </th>
                        <th
                            scope="col"
                            class="col-2"
                            *ngIf="isInOrg"
                            title="{{
                                'user.userArea.apiManagement.organization.groupAdvice'
                                    | translate
                            }}"
                        >
                            {{
                                'user.userArea.apiManagement.organization.group'
                                    | translate
                            }}
                            <img
                                class="icon"
                                src="assets/svg/algorithm/info-hover.svg"
                                alt="info circle"
                            />
                        </th>
                        <th scope="col" class="col-1 right">
                            {{
                                'user.userArea.apiManagement.active' | translate
                            }}
                        </th>
                        <th scope="col" class="col-1 right">
                            {{
                                'user.userArea.apiManagement.delete' | translate
                            }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let token of tokens; let i = index">
                        <td class="d-flex">
                            <img
                                class="icon"
                                [ngClass]="{ disabled: !token.active }"
                                [src]="
                                    'assets/svg/user-area/icon-copy-to-clipboard' +
                                    (!token.active
                                        ? '-disabled'
                                        : hoveredCopyToClipboardButton === i
                                          ? '-hover'
                                          : '') +
                                    '.svg'
                                "
                                alt="copy to clipboard button"
                                (click)="
                                    token.active
                                        ? onCopyToClipboard(token.opaqueToken)
                                        : null
                                "
                                (mouseenter)="hoveredCopyToClipboardButton = i"
                                (mouseleave)="
                                    hoveredCopyToClipboardButton = null
                                "
                            />
                            <p
                                class="token"
                                [ngClass]="{ disabled: !token.active }"
                            >
                                {{ token.opaqueToken }}
                            </p>
                        </td>
                        <td class="text-break">
                            <input
                                class="form-control"
                                [ngClass]="{ disabled: !token.active }"
                                [formControl]="tokenNameForm.get('' + i)"
                                type="text"
                                (blur)="onChangeName($event, token, i)"
                                (keydown.enter)="onChangeName($event, token, i)"
                                (keydown.escape)="
                                    onResetTokenName($event, token, i)
                                "
                                maxlength="30"
                            />
                            <div
                                class="error-div"
                                *ngIf="
                                    !tokenNameForm.get('' + i).pristine &&
                                    tokenNameForm.get('' + i).invalid
                                "
                            >
                                <app-display-errors
                                    [control]="tokenNameForm.get('' + i)"
                                    [translationKey]="
                                        'user.userArea.apiManagement.errors'
                                    "
                                ></app-display-errors>
                            </div>
                        </td>
                        <td *ngIf="isInOrg">
                            <p
                                class="group-text"
                                *ngFor="
                                    let groupId of token.organizationGroups;
                                    let last = last
                                "
                                [title]="groups[groupId]"
                            >
                                {{ groups[groupId] }}{{ last ? '' : ', ' }}
                            </p>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end">
                                <div
                                    class="toggle-wrapper"
                                    [class.checked]="token.active"
                                    (click)="onActiveToggleChange(token, i)"
                                >
                                    <div class="toggle-knob"></div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end">
                                <img
                                    class="icon"
                                    [src]="
                                        'assets/svg/reusable-svg/icon-trash-can' +
                                        (hoveredDeleteButton === i
                                            ? '-hover'
                                            : '') +
                                        '.svg'
                                    "
                                    alt="delete token button"
                                    (click)="onOpenTokenDeletionDialog(token)"
                                    (mouseenter)="hoveredDeleteButton = i"
                                    (mouseleave)="hoveredDeleteButton = null"
                                />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-between w-100 align-items-center">
            <button
                aria-hidden="true"
                type="button"
                class="add-token-button placeholder"
            >
                {{ 'user.userArea.apiManagement.addToken' | translate }}
            </button>
            <div class="pagination-navigation">
                <app-simple-tryb-pagination
                    [collectionSize]="collectionSize"
                    [page]="page"
                    [pageSize]="pageSize"
                    [maxSize]="maxSize"
                    (pageChange)="onPageChange($event)"
                ></app-simple-tryb-pagination>
            </div>
            <button
                type="button"
                class="add-token-button"
                (click)="onTokenAddButtonClick()"
            >
                {{ 'user.userArea.apiManagement.addToken' | translate }}
            </button>
        </div>
    </ng-container>
    <div class="d-flex justify-content-center" *ngIf="isLoading">
        <div class="spinner-wrapper">
            <div class="tryb-design-spinner"></div>
        </div>
    </div>
</div>
